// extracted by mini-css-extract-plugin
export var baseButton = "_qd-0";
export var controlsArrowKeys = "_qd-1";
export var controlsResetButton = "_qd-2";
export var lightGameButton = "_qd-4 _qd-0";
export var playAgainButton = "_qd-5 _qd-0";
export var startGameButton = "_qd-3 _qd-0";